import type { PlaceRef } from '@/model/DeliveryNote'
import type Place from '@/model/Place'

export function hasPlaceRef(ref?: PlaceRef): boolean {
  return !!(ref?.id?.trim() || ref?.name?.trim())
}

export function nonEmptyPlaceRefs(refs: PlaceRef[]): PlaceRef[] {
  return refs.filter(hasPlaceRef)
}

export function clonePlaceRefs(refs: PlaceRef[]): PlaceRef[] {
  return nonEmptyPlaceRefs(refs).map((ref) => ({
    id: ref.id?.trim() ? ref.id : undefined,
    name: ref.name?.trim() || undefined,
  }))
}

export function placeRefKey(ref: PlaceRef, index: number): string {
  if (ref.id?.trim()) {
    return `id:${ref.id}`
  }
  return `name:${ref.name ?? ''}:${index}`
}

export function resolvePlaceRefTitle(ref: PlaceRef, catalog: Place[]): string {
  if (ref.id?.trim()) {
    const place = catalog.find((p) => p.id === ref.id)
    return place?.name ?? ref.name ?? ''
  }
  return ref.name?.trim() ?? ''
}

export function resolvePlaceRefSubtitle(
  ref: PlaceRef,
  catalog: Place[],
  manualLabel: string
): string {
  if (ref.id?.trim()) {
    const place = catalog.find((p) => p.id === ref.id)
    return place?.city?.trim() || place?.address?.trim() || ''
  }
  return manualLabel
}

export function isCatalogPlaceRef(ref: PlaceRef): boolean {
  return !!ref.id?.trim()
}
